
export enum ClaimFilingMethodCd {
	API = 'API',
	EMAIL = 'Email',
	FAX = 'Fax',
	MAIL = 'Mail',
	WEB = 'Web'}

